import React, { memo } from "react";
import { Button, Modal } from "antd";

const IVFIdModal = ({ isOpenIVFIdAlert, setIsOpenIVFIdAlert }) => {
  const theme = localStorage.getItem("default-theme");

  return (
    <Modal
      centered
      open={isOpenIVFIdAlert}
      title="Please complete the previous IVF cycle details"
      className={`reminderModal ivf_id_alert_modal theme-${theme}`}
      maskClosable={false}
    >
      <div className="d-flex justify-content-center gap-2">
        <Button
          className="btn_gray close_btn"
          onClick={() => {
            setIsOpenIVFIdAlert(false);
          }}
        >
          Ok
        </Button>
      </div>
    </Modal>
  );
};

export default memo(IVFIdModal);
